module.exports = __webpack_public_path__ + "img/lanmu-03.2f27057b.jpg";